import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=29e4807a&scoped=true&"
import script from "./PasswordChange.vue?vue&type=script&lang=js&"
export * from "./PasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=29e4807a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e4807a",
  null
  
)

export default component.exports